/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    LogoutRequestDTO,
    LogoutRequestDTOFromJSON,
    LogoutRequestDTOToJSON,
    RequestDTO,
    RequestDTOFromJSON,
    RequestDTOToJSON,
} from '../models';

export interface CodeRequest {
    code?: string;
    state?: string;
    errorDescription?: string;
}

export interface CreateRequestRequest {
    forced?: boolean;
    state?: string;
}

/**
 * 
 */
export class AuthenticationControllerApi extends runtime.BaseAPI {

    /**
     */
    async codeRaw(requestParameters: CodeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.code !== undefined) {
            queryParameters['code'] = requestParameters.code;
        }

        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }

        if (requestParameters.errorDescription !== undefined) {
            queryParameters['error_description'] = requestParameters.errorDescription;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/authentication/code`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async code(code?: string, state?: string, errorDescription?: string, initOverrides?: RequestInit): Promise<void> {
        await this.codeRaw({ code: code, state: state, errorDescription: errorDescription }, initOverrides);
    }

    /**
     */
    async createLogoutRequestRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<LogoutRequestDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/authentication/createLogoutRequest`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogoutRequestDTOFromJSON(jsonValue));
    }

    /**
     */
    async createLogoutRequest(initOverrides?: RequestInit): Promise<LogoutRequestDTO> {
        const response = await this.createLogoutRequestRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async createRequestRaw(requestParameters: CreateRequestRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<RequestDTO>> {
        const queryParameters: any = {};

        if (requestParameters.forced !== undefined) {
            queryParameters['forced'] = requestParameters.forced;
        }

        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/authentication/createRequest`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RequestDTOFromJSON(jsonValue));
    }

    /**
     */
    async createRequest(forced?: boolean, state?: string, initOverrides?: RequestInit): Promise<RequestDTO> {
        const response = await this.createRequestRaw({ forced: forced, state: state }, initOverrides);
        return await response.value();
    }

    /**
     */
    async logoutRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/authentication/logout`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async logout(initOverrides?: RequestInit): Promise<void> {
        await this.logoutRaw(initOverrides);
    }

}
